import { useState, useEffect } from 'react'
import { bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
import { useSearchParams } from 'react-router-dom'
import { correctPlanningCategory } from "../../redux/Actions/PowerDataQuery";
import {  useMsal } from "@azure/msal-react";
import CustomMessageAlert from "../CustomMessageAlert/CustomMessageAlert";
import { TextField } from '@fluentui/react/lib/TextField';

import {
    Dialog,
    DialogFooter,
    DialogType,
    PrimaryButton,
    DefaultButton,
  } from '@fluentui/react'

import './ArticleCategory.css'

const actionCreators = {
    correctPlanningCategory,
};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
    apiResponseState: state.apiResponseState,
    reviewContentMarker: state.reviewContentMarker,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected,
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

interface IMessageState {
    showMessage: boolean,
    messageType: string,
    message: string,
    onDismiss?: () => void
}

interface ArticleClose {
    Category?: string,
    CategoryValue?: string,
    onDismiss?: () => void
    onLoadArticleInfo?: (articleInfo) => void
}

// const multilineObservable = new ObservableValue<string>("");


/**
 * broken link checker
 * @param props 
 * @returns 
 */
function ArticleCategory(props: StoreProps & DispatchProps & ArticleClose ) {
    const { accounts } = useMsal();
    const [search] = useSearchParams();
    const requesturl = search.get('url')
    const ticketID = search.get('ticketID')
    const curationID = search.get('curationID')
    const datamart = search.get('datamart')


    // set the healing complete params
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showError, setShowError] = useState<boolean>(false)
    const [CategoryValue, setCategoryValue] = useState<string>(props.CategoryValue)

    
    const [multilineObservable, setMultilineObservable] = useState<string>("")

    // const identityPickerChange = useCallback((data: string)=>{
    //     setUser(data)
    // },[])


    const [messageState, setMessageState] = useState<IMessageState>(() => {
        return {
            showMessage: false,
            messageType: '',
            message: '',
            onDismiss: null
        }
    })

    const dismissAlert = () => {
        setMessageState({
            messageType: '',
            showMessage: false,
            message: ''
        })
    }

    /**
     * Get the content from the api
     */
    useEffect(() => {
        // when the url is empty, show the error dialog
        if (!requesturl) {
            window.location.href = `https://aka.ms/ChironDocs`
            return
        }

    }, [])

    function onDispute() {
        var data = {
            TypeName: props.Category,
            OldValue: props.CategoryValue,
            NewValue: CategoryValue,
            Reason: multilineObservable,
            TicketGuid: ticketID,
        };

        if (CategoryValue == "" || CategoryValue == null) {

            setMessageState({
                messageType: 'error',
                showMessage: true,
                message: `Please enter required fields!`,
                onDismiss: dismissAlert
            })

            setTimeout(() => {
                dismissAlert();
            }, 1500);
            return false;
        }

        setIsLoading(true);
        correctPlanningCategory(data).then(res => {
            setIsLoading(false);

            if (res.Success) {
                InitFrom();
                props.onDismiss();
                props.onLoadArticleInfo({
                    CategoryValue: CategoryValue
                })

                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })

                setTimeout(() => {
                    dismissAlert();
                }, 1500);
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Report failed, detail:${res.ErrorMessage ? res.ErrorMessage : 'Unknown error, please try again later!'}`,
                    onDismiss: dismissAlert
                })

                setTimeout(() => {
                    dismissAlert();
                }, 2000);
            }

        })

    }

    function InitFrom() {
        // multilineObservable.value = "";
        setMultilineObservable("");
        // identityPickerChange(undefined);
    }

    return (
        <Dialog
            // titleProps={{ text: "Edit Article Category" }}
            // footerButtonProps={[
            //     {
            //         text: "Submit",
            //         primary: true,
            //         disabled: isLoading,
            //         onClick: onDispute
            //     },
            //     {
            //         text: "Close",
            //         onClick: ()=>{
            //             InitFrom();
            //             props.onDismiss();
            //         }
            //     }
            // ]}
            // calloutContentClassName='category-dialog'
            dialogContentProps={{
                type: DialogType.normal,
                title: 'Edit Article Category',
            }}
            modalProps={{
                isBlocking: true,
                className: 'category-dialog',
            }}
            onDismiss={props.onDismiss}
        >

            <div style={{ width: "100%" }}>

                <div style={{ width: '50%', position: 'relative', marginLeft: "25%" }}>
                    <CustomMessageAlert
                        type={messageState.messageType}
                        message={messageState.message}
                        showAlert={messageState.showMessage}
                        onDismiss={messageState.onDismiss}
                    />
                </div>

                <div className='cardTop'>

                    <div>
                        <span><span style={{ color: "red" }}>*</span> {props.Category} :</span>
                        <div style={{ float: "right", width: "80%", marginRight: "3%" }}>
                            <TextField
                                value={CategoryValue}
                                onChange={(e, newValue) => {
                                    setCategoryValue(newValue);
                                    if (newValue == "" || newValue == null) {
                                        setShowError(true);
                                    } else {
                                        setShowError(false);
                                    }
                                }}
                                placeholder="Please enter required fields"
                            />
                            {
                                showError ? <div style={{ color: "red" }}>Please enter required fields</div> : null
                            }
                        </div>
                    </div>
                    <div className='cardInputTop'>
                        <span> Reason :</span>
                        <div style={{ float: "right", width: "80%", marginRight: "3%" }}>
                            <TextField label="" multiline rows={3} className='DropdownWidth' value={multilineObservable}
                                onChange={(e, newValue) => (setMultilineObservable(newValue))} />
                        </div>
                    </div>
                </div>

            </div>

            <DialogFooter>
                <PrimaryButton
                    text="Submit"
                    onClick={onDispute}
                    disabled={isLoading}
                />
                <DefaultButton
                    text="Close"
                    onClick={() => {
                        InitFrom();
                        props.onDismiss();
                    }}
                />
            </DialogFooter>

        </Dialog>

    )
}

export default connect<StoreProps, DispatchProps>(
    mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(ArticleCategory);
